<ng-template #content let-modal>
  <div class="modal-body">
    <div class="row slide" *ngIf="current === 1">
      <div class="col-12 flex">
        <!-- <svg style="margin-bottom: 30px;" xmlns="http://www.w3.org/2000/svg" width="140" height="140"
          viewBox="0 0 140 140">
          <g id="Grupo_98" data-name="Grupo 98" transform="translate(-140.83 -207.333)">
            <path id="Trazado_38" data-name="Trazado 38"
              d="M204.769,230.427c16.224,9.523,24.51,23.392,24.5,42.023l1.235.4,5.469-8.961c10.315,14.269,16.045,40.264-2.66,55.21a78.311,78.311,0,0,1-7.29,4.73c1.749-4.266,4.242-8.62,5.265-13.283,1.263-5.754-1.142-11.055-4.653-15.767-2.062-2.769-4.594-5.315-6.1-8.348-2.24-4.524-3.756-9.39-5.629-14.238-9.583,7.722-11.728,18.52-10.968,30.8-5.44-2.476-5.888-6.976-6.454-11.434-7.968,7.634-7.6,22.68.72,31.913-4.165-.617-10.169-5.027-14.03-10.307-8.675-11.862-8.667-27.688.215-40.6,2.856-4.154,6.092-8.063,9.222-12.036,6.448-8.185,10.252-17.3,10.425-27.729a8.521,8.521,0,0,1,.14-1.459C204.219,231.128,204.424,230.946,204.769,230.427Z"
              transform="translate(-0.797 0.204)" fill="#fff" />
            <g id="Grupo_89" data-name="Grupo 89" transform="translate(140.83 207.333)">
              <path id="Trazado_39" data-name="Trazado 39"
                d="M210.83,347.333a70,70,0,1,1,70-70A70.079,70.079,0,0,1,210.83,347.333Zm0-133.05a63.05,63.05,0,1,0,63.05,63.05A63.121,63.121,0,0,0,210.83,214.283Z"
                transform="translate(-140.83 -207.333)" fill="#fff" />
            </g>
          </g>
        </svg> -->
        <h2 class="centered">bienvenido a nuestra sección de juegos</h2>
        <p>A continuación te explicamos para qué sirve cada botón que encontrarás dentro de la sección.</p>
      </div>
    </div>
    <div class="row slide" *ngIf="current === 2">
      <div class="col-12 flex">
        <svg class="mt30" xmlns="http://www.w3.org/2000/svg" width="87" height="87" viewBox="0 0 87 87">
          <g id="Grupo_113" data-name="Grupo 113" transform="translate(-137 -299)">
            <g id="Elipse_21" data-name="Elipse 21" transform="translate(137 299)" fill="none" stroke="#fff"
              stroke-width="3">
              <circle cx="43.5" cy="43.5" r="43.5" stroke="none" />
              <circle cx="43.5" cy="43.5" r="42" fill="none" />
            </g>
            <path id="Trazado_47" data-name="Trazado 47"
              d="M171.413,52.333A30.583,30.583,0,1,0,202,82.916,30.618,30.618,0,0,0,171.413,52.333Zm9.324,49.066a33.589,33.589,0,0,1-3.135,2.083,37.064,37.064,0,0,0,2.264-5.849c.543-2.534-.491-4.868-2-6.943a25.767,25.767,0,0,1-2.621-3.676c-.963-1.992-1.615-4.135-2.421-6.27-4.121,3.4-5.043,8.155-4.716,13.562-2.339-1.09-2.532-3.072-2.775-5.035-3.426,3.362-3.269,9.987.31,14.053-1.791-.272-4.373-2.214-6.033-4.539a15.529,15.529,0,0,1,.092-17.879c1.228-1.829,2.62-3.551,3.965-5.3A20.166,20.166,0,0,0,168.15,63.4a3.838,3.838,0,0,1,.06-.642c.017-.094.105-.174.254-.4,6.976,4.194,10.54,10.3,10.535,18.5l.531.178,2.352-3.946C186.317,83.371,188.781,94.818,180.737,101.4Z"
              transform="translate(9.003 259.583)" fill="#fff" />
          </g>
        </svg>

        <p class="mt30">Haz clic en estos botones para acceder a más información.</p>
        <a  class="mt30 btn-theme game-btn glossary">
          <svg xmlns="http://www.w3.org/2000/svg" width="25.188" height="31" viewBox="0 0 25.188 31">
            <g id="bookmarks-sharp" transform="translate(-48)">
              <path id="Trazado_55" data-name="Trazado 55" d="M112,0V2.906h18.406V25.188l2.906,1.938V0Z"
                transform="translate(-60.125)" fill="#fff" />
              <path id="Trazado_56" data-name="Trazado 56" d="M48,80v26.156l10.172-7.508,10.172,7.508V80Z"
                transform="translate(0 -75.156)" fill="#fff" />
            </g>
          </svg>
          Glosario
        </a>
        <p class="mt30">Haz clic en este botón para acceder a toda la información de nuestro Glosario.</p>
      </div>
    </div>
    <div class="row slide" *ngIf="current === 3">
      <div class="col-12 flex">

        <a class="mt30 btn-theme game-btn resources">
          <svg xmlns="http://www.w3.org/2000/svg" width="35.246" height="37.764" viewBox="0 0 35.246 37.764">
            <g id="file-tray-stacked-sharp" transform="translate(-32 -16)">
              <path id="Trazado_40" data-name="Trazado 40"
                d="M64.729,16H34.518L32,28.588V39.917H67.246V28.588Zm-.944,12.588H54.658a5.035,5.035,0,0,1-10.07,0H35.462L37.193,19.3H62.054Z"
                fill="#fff" />
              <path id="Trazado_41" data-name="Trazado 41"
                d="M54.658,352a5.035,5.035,0,0,1-10.07,0H32v11.329H67.246V352Z" transform="translate(0 -309.565)"
                fill="#fff" />
            </g>
          </svg>
        </a>
        <p class="mt30">Haz clic en este botón para acceder a todos los recursos multimedia.</p>

        <a class="mt30 btn-theme ts-background-4 game-btn user">
          <svg xmlns="http://www.w3.org/2000/svg" width="32.456" height="34.952" viewBox="0 0 32.456 34.952">
            <g id="person" transform="translate(-47.994 -32)">
              <path id="Trazado_42" data-name="Trazado 42"
                d="M166.092,34.542a8.336,8.336,0,0,0-11.971-.016,8.258,8.258,0,0,0-2.1,6.3c.346,4.768,3.975,8.647,8.089,8.647s7.736-3.878,8.088-8.646A8.234,8.234,0,0,0,166.092,34.542Z"
                transform="translate(-95.891)" fill="#fff" />
              <path id="Trazado_43" data-name="Trazado 43"
                d="M77.953,302.979H50.491a2.419,2.419,0,0,1-1.888-.868,2.755,2.755,0,0,1-.56-2.271,13.358,13.358,0,0,1,5.943-8.875,19.153,19.153,0,0,1,20.472,0,13.354,13.354,0,0,1,5.943,8.874,2.755,2.755,0,0,1-.56,2.271A2.418,2.418,0,0,1,77.953,302.979Z"
                transform="translate(0 -236.028)" fill="#fff" />
            </g>
          </svg>
        </a>
        <p class="mt30">Haz clic en este botón para acceder al perfil de Profesores.</p>
      </div>
    </div>
    <div class="row slide" *ngIf="current === 4">
      <div class="col-12 flex">

        <a style="left: 0;" class="mt30 btn-theme ts-background-4 game-btn play">
          Jugar
          <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80">
            <g id="Grupo_101" data-name="Grupo 101" transform="translate(-140.657 -207.16)">
              <ellipse id="Elipse_23" data-name="Elipse 23" cx="39.96" cy="39.96" rx="39.96" ry="39.96"
                transform="translate(140.657 207.16)" fill="#f5d200" />
              <path id="Trazado_38" data-name="Trazado 38"
                d="M192.906,230.427c9.114,5.47,13.769,13.437,13.762,24.138l.694.232,3.072-5.147c5.795,8.2,9.014,23.128-1.494,31.713a43.9,43.9,0,0,1-4.1,2.717c.983-2.45,2.383-4.951,2.958-7.63.71-3.305-.642-6.35-2.614-9.057a33.65,33.65,0,0,1-3.424-4.8c-1.258-2.6-2.11-5.394-3.162-8.179-5.383,4.435-6.588,10.638-6.161,17.692-3.056-1.422-3.307-4.007-3.626-6.568-4.476,4.385-4.27,13.028.4,18.331-2.34-.354-5.712-2.888-7.881-5.92-4.873-6.814-4.869-15.9.121-23.322,1.6-2.386,3.422-4.632,5.18-6.913A26.282,26.282,0,0,0,192.5,231.79a5,5,0,0,1,.079-.838C192.6,230.83,192.712,230.725,192.906,230.427Z"
                transform="translate(-16.015 -10.006)" fill="#fff" />
              <g id="Grupo_89" data-name="Grupo 89" transform="translate(140.83 207.333)">
                <path id="Trazado_39" data-name="Trazado 39"
                  d="M180.744,287.16a39.914,39.914,0,1,1,39.914-39.914A39.959,39.959,0,0,1,180.744,287.16Zm0-75.864a35.951,35.951,0,1,0,35.951,35.951A35.991,35.991,0,0,0,180.744,211.3Z"
                  transform="translate(-140.83 -207.333)" fill="#fff" />
              </g>
            </g>
          </svg>
        </a>
        <p class="mt30">Haz clic en este botón para acceder al Juego que preparamos para ti</p>


        <a (click)="modal.dismiss('Cross click')" style="margin-top: 50px !important;" class="btn-theme ts-background-4 ">
          Empecemos
        </a>

      </div>
    </div>
    <div class="navigation">
      <a (click)="switchSlide('prev')"  class="arrow left">
        <svg xmlns="http://www.w3.org/2000/svg" width="85" height="85" viewBox="0 0 85 85">
          <g id="Grupo_87" data-name="Grupo 87" transform="translate(-1142 -30)">
            <path id="Trazado_35" data-name="Trazado 35" d="M2420,308.187l21.85,21.85,21.85-21.85" transform="translate(1503.537 -2369.5) rotate(90)" fill="none" stroke="#fff" stroke-width="7"/>
          </g>
        </svg>
      </a>

      <a (click)="switchSlide('next')" class="arrow right">
        <svg xmlns="http://www.w3.org/2000/svg" width="85" height="85" viewBox="0 0 85 85">
          <g id="Grupo_87" data-name="Grupo 87" transform="translate(-1142 -30)">
            <path id="Trazado_35" data-name="Trazado 35" d="M2420,308.187l21.85,21.85,21.85-21.85" transform="translate(1503.537 -2369.5) rotate(90)" fill="none" stroke="#fff" stroke-width="7"/>
          </g>
        </svg>
      </a>
      <div class="bullet-box">
        <span class="bullet" (click)="switchSlide(1)" [class.active]="current===1"></span>
        <span class="bullet" (click)="switchSlide(2)" [class.active]="current===2"></span>
        <span class="bullet" (click)="switchSlide(3)" [class.active]="current===3"></span>
        <span class="bullet" (click)="switchSlide(4)" [class.active]="current===4"></span>
      </div>
    </div>
  </div>



  <a class="btn-close" (click)="modal.dismiss('Cross click')">
    <svg xmlns="http://www.w3.org/2000/svg" width="46.669" height="46.669" viewBox="0 0 46.669 46.669">
      <g id="close" transform="translate(-41.665 -25.665)">
        <rect id="Rectángulo_3" data-name="Rectángulo 3" width="60" height="6"
          transform="translate(45.908 25.665) rotate(45)" fill="#fff" />
        <rect id="Rectángulo_41" data-name="Rectángulo 41" width="60" height="6"
          transform="translate(88.334 29.908) rotate(135)" fill="#fff" />
      </g>
    </svg>
  </a>
</ng-template>
